import React, { useState } from 'react';
import SamplingPlans from './SamplingPlans';
import AcceptanceCriteria from './AcceptanceCriteria';
import { useModuleAccess } from '../utils/moduleAccess';

const ALL_TABS = [
  { k: 'sampling-plan', l: 'Sampling Plan', module: 'sampling_plans' },
  { k: 'acceptance-criteria', l: 'Acceptance Criteria', module: 'acceptance_criteria' }
];

const SamplingAndAcceptance = () => {
  const moduleOn = useModuleAccess();
  const TABS = ALL_TABS.filter((tab) => moduleOn(tab.module));
  const [chosenTab, setActiveTab] = useState('sampling-plan');
  const activeTab = TABS.some((tab) => tab.k === chosenTab) ? chosenTab : TABS[0]?.k;

  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <div className="lms-tabs !mb-0">
          {TABS.map((t) => (
            <button
              key={t.k}
              type="button"
              onClick={() => setActiveTab(t.k)}
              className={`lms-tab ${activeTab === t.k ? 'active' : ''}`}
            >
              {t.l}
            </button>
          ))}
        </div>
      </div>

      {moduleOn('sampling_plans') && (
        <div style={{ display: activeTab === 'sampling-plan' ? 'block' : 'none' }}>
          <SamplingPlans />
        </div>
      )}
      {moduleOn('acceptance_criteria') && (
        <div style={{ display: activeTab === 'acceptance-criteria' ? 'block' : 'none' }}>
          <AcceptanceCriteria />
        </div>
      )}
    </div>
  );
};

export default SamplingAndAcceptance;
